import { ApiResponse } from "@/types";
import { RefundRequestResponse, WalletRequestResponse, WalletRequestStatus } from "@/types/wallet";
import { apiSlice } from "@/redux/apiSlice";

interface QueryInput {
  query: string;
  org_id: number;
}

interface UpdateTransaction {
  id: number;
  status: WalletRequestStatus;
  rejection_reason?: string;
  org_id: number;
}

export const Wallet = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getWalletRequests: builder.query<WalletRequestResponse, QueryInput>({
        query: (searchCretiria) => ({
          url: `/bank-transfers?org_id=${searchCretiria.org_id}&${searchCretiria.query}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Wallet"],
      }),
      approvedRequest: builder.mutation<ApiResponse, UpdateTransaction>({
        query: (data) => ({
          url: `/bank-transfer/${data.id}`,
          method: "PUT",
          body: data,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Wallet","Invoice"],
      }),
      rejectedRequest: builder.mutation<ApiResponse, UpdateTransaction>({
        query: (data) => ({
          url: `/bank-transfer/${data.id}`,
          method: "PUT",
          body: data,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Wallet"],
      }),
      getRefundWalletRequests: builder.query<RefundRequestResponse, QueryInput>(
        {
          query: (searchCretiria) => ({
            url: `/admin/refund-requests?org_id=${searchCretiria.org_id}&${searchCretiria.query}`,
            method: "GET",
            headers: {
              Accept: "application/json",
            },
          }),
          providesTags: ["RefundWallet"],
        }
      ),
      approvedRefundRequest: builder.mutation<ApiResponse, UpdateTransaction>({
        query: (data) => ({
          url: `/admin/refund-requests/${data.id}?org_id=${data.org_id}`,
          method: "PUT",
          body: data,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["RefundWallet"],
      }),
      rejectRefundRequest: builder.mutation<ApiResponse, UpdateTransaction>({
        query: (data) => ({
          url: `/admin/refund-requests/${data.id}?org_id=${data.org_id}`,
          method: "PUT",
          body: data,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["RefundWallet"],
      }),
    };
  },
});

export const {
  useGetWalletRequestsQuery,
  useApprovedRequestMutation,
  useRejectedRequestMutation,
  useGetRefundWalletRequestsQuery,
  useApprovedRefundRequestMutation,
  useRejectRefundRequestMutation,
} = Wallet;
